import { createContext, useContext, useEffect, useId } from 'react';

export interface LoyaltyWidgetContainerContextValue {
  publishedText?: string;
  publishText: (publisherId: string, text: string | undefined) => void;
}

export const LoyaltyWidgetContainerContext = createContext<LoyaltyWidgetContainerContextValue | undefined>(undefined);

// Child sections resolve their AEM templates then publish the final badge string.
export const useLoyaltyWidgetBadgePublisher = (text: string | undefined): void => {
  const ctx = useContext(LoyaltyWidgetContainerContext);
  const publisherId = useId();

  useEffect(() => {
    if (!ctx) return undefined;
    ctx.publishText(publisherId, text);
    return () => ctx.publishText(publisherId, undefined);
  }, [ctx, publisherId, text]);
};
